import { cn } from '@design-system';
import { useEmailFrame } from '../hooks/use-email-frame';

/** The reply email's own font (`composeReply.ts`), so the header matches the body. */
const EMAIL_FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif";

const now = () => new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

/** An email as the advisor's inbox would show it: subject, sender, then the body the server built. */
export function EmailFrame(props: {
  subject: string;
  from: string;
  html: string;
  title: string;
  dimmed?: boolean;
}) {
  const frame = useEmailFrame(props.html);

  return (
    <div
      className="flex flex-col gap-4"
      style={{ fontFamily: EMAIL_FONT }}
    >
      <h3 className="text-[19px] font-semibold text-gray-900">{props.subject}</h3>
      <div className="flex items-center gap-3">
        <span
          aria-hidden
          className="flex size-10 flex-none items-center justify-center rounded-full bg-[#5B3FD6] text-base font-semibold text-white"
        >
          W
        </span>
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <span className="truncate text-sm text-gray-900">
            <strong className="font-semibold">Waterlily</strong>{' '}
            <span className="text-gray-500">&lt;{props.from}&gt;</span>
          </span>
          <span className="text-[13px] text-gray-500">to you</span>
        </div>
        <span className="text-[13px] text-gray-500">{now()}</span>
      </div>
      <iframe
        title={props.title}
        sandbox="allow-same-origin"
        srcDoc={frame.srcDoc}
        onLoad={frame.onLoad}
        style={{ height: frame.height }}
        className={cn('w-full border-0 transition-opacity', props.dimmed && 'opacity-70')}
      />
    </div>
  );
}
